module.exports = __webpack_public_path__ + "img/comment_bad_icon.84aaf89d.png";